<template>
  <v-expansion-panels
          class="mb-5 mt-8"
  >
    <v-expansion-panel>
      <v-expansion-panel-header>Tìm kiếm lịch sử đơn hàng</v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card class="ma-0" outlined>
          <v-list-item class="pa-0" three-line>
            <v-list-item-content class="pa-0">
<!--              <v-list-item-title class="headline mb-2">Tìm kiếm</v-list-item-title>-->
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field
                          v-model="filterForm.code"
                          placeholder="Tìm kiếm ..."
                          clearable
                          @keyup.enter="searchContact"
                  />
                </v-col>
              </v-row>
              <div class="text-center mb-4">
                <v-btn class="primary mx-0" @click="searchContact">
                  <v-icon>mdi-magnify</v-icon>Tìm kiếm
                </v-btn>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>
export default {
  props: {
    filterForm: {
      default: () => ({})
    }
  },
  methods: {
    searchContact() {
      Bus.$emit('order-list-filter', this.filterForm);
    }
  }
};
</script>
